import { FETCH_POIS, SET_HOVERED_POI_ID, SET_POI, SET_POIS } from "./constants";
import { api } from "../../config";
import { setFiltered } from "../filtered";
import axios from "axios";

export const getPois = ({ state }) => () =>
	new Promise(resolve => {
		resolve(state);
	});
export const fetchPois = () => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		const { pois } = getState();
		axios(api.url)
			// then((res) => res.json()).
			.then(res => {
				const data = res.data.rows;
				axios(api.files)
					// then((response) => response.json()).
					.then(files => {
						const medias = files.data.media.data.reduce((items, item) => {
							items[item.idlot] = item;
							return items;
						}, {});
						const p = data.reduce((all, poi) => {
							const { lot } = poi;
							if (pois[building][lot]) {
								all[lot] = {
									...pois[building][lot],
									// lot: poi.lot,
									type: `${poi.type}`,
									floor: `${poi.floor}`,
									price: `${poi.price}`,
									surface: `${poi.surface}`,
									visible: `${poi.visible}`,
									plan: `${
										medias[poi.idlot]
											? api.fileRoot + medias[poi.idlot].fileurl
											: ""
									}`
								};
							}
							return all;
						}, {});
						dispatch({
							type: FETCH_POIS,
							pois: {
								[building]: {
									...p
								}
							}
						});
						dispatch(setFiltered());
						resolve(pois);
					})
					.catch(err => console.error(err));
			})
			.catch(err => {
				console.log(err);
			});
	});
export const setPois = routeName => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_POIS,
			routeName,
			building
		});
		resolve(routeName);
	});
export const getPoi = poi => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_POI,
			poi,
			building
		});
		resolve(poi);
	});

export const setHoveredPoiId = poi => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_POI,
			poi,
			building
		});
		resolve(poi);
	});
